import { useNavigate } from "react-router-dom";
import { Button } from "@/ui";
import { useSession } from "./_shims";
import { useMatchCards } from "./lib/hooks";
import { MatchModal } from "./components/MatchModal";
import { MatchRow } from "./components/MatchRow";
import { useMatchOpener } from "./components/useMatchOpener";
import s from "./network.module.css";

/** Up to three "Waiting on you" introductions for the Home feed. Null when signed out or nothing is waiting. */
export function HomeMatchesWidget() {
  const navigate = useNavigate();
  const { isSignedIn } = useSession();
  const cards = useMatchCards();
  const opener = useMatchOpener();
  if (!isSignedIn) return null;
  const waiting = (cards.data?.cards ?? []).filter((c) => c.section === "waiting_on_you").slice(0, 3);
  if (waiting.length === 0) return null;
  return (
    <div className={s.widget} data-testid="home-matches-widget">
      <div className={s.widgetHead}>
        <span>Introductions waiting on you</span>
        <Button size="sm" variant="ghost" onClick={() => navigate("/matches")}>
          See all
        </Button>
      </div>
      <div className={s.stack}>
        {waiting.map((c) => (
          <MatchRow key={c.matchId} card={c} compact onOpen={opener.open} onAction={opener.act} />
        ))}
      </div>
      <MatchModal card={opener.modal?.card ?? null} initialAction={opener.modal?.action ?? null} onClose={opener.close} />
    </div>
  );
}
